import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import i18n from "@/translate/i18n";
import Button from "@/components/atoms/Buttons/Button";
import { ReactComponent as SuccessIcon } from "@/assets/images/transactionOk.svg";
import { LayoutWrapper1xbet } from "@/components/molecules/Wrappers/LayoutWrapper1xbet";
import { useTransactionData } from "@/context/transactionContext";

function SucessMessage1xbet() {
  const { transactionData: contextData } = useTransactionData();
  const location = useLocation();

  const transactionData = useMemo(() => {
    if (location.state?.data) return location.state.data;
    return contextData;
  }, [location.state, contextData]);

  return (
    <LayoutWrapper1xbet>
      <div className="flex flex-col items-center">
        <SuccessIcon className="w-32" />
        {transactionData?.type === "deposit" ? (
          <>
            <div className="mt-1">
              <h2 className="text-black font-semibold text-2xl tracking-wider">
                {i18n.t("success.title")}
              </h2>
            </div>
            <h3 className="mt-5 font-semibold text-lg text-light-gray">
              {i18n.t("success.subtitle")}
            </h3>
          </>
        ) : (
          <>
            <div className="mt-8">
              <h2 className="text-black font-bold text-xl">
                {i18n.t("transactionStatus.title")}
              </h2>
            </div>
            <h3 className="mt-5 font-medium text-md text-black">
              {i18n.t("transactionStatus.subtitle")}
            </h3>
            <h3 className="mt-5 font-medium text-md text-black">
              {i18n.t("transactionStatus.info")}
              <strong>{i18n.t("transactionStatus.info2")}</strong>
            </h3>
          </>
        )}
      </div>
      <h3 className="mt-5 font-medium text-md text-black">
        {transactionData?.type === "deposit" ? (
          <>
            {i18n.t("success.info")}
            <strong>{i18n.t("success.info2")}</strong>
          </>
        ) : (
          <>
            {i18n.t("transactionStatus.info")}
            <strong>{i18n.t("transactionStatus.info2")}</strong>
          </>
        )}
      </h3>
      {transactionData?.redirect_url_success && (
        <Button
          id="backToMerchant"
          type="button"
          handleClick={() => {
            window.location.href = transactionData.redirect_url_success;
          }}
        >
          {i18n.t("general.backTo", {
            merchant: transactionData?.merchant?.name,
          })}
        </Button>
      )}
    </LayoutWrapper1xbet>
  );
}

export default SucessMessage1xbet;
